export default class VoucherCount {
    static init(): void {

        const modals = document.querySelectorAll('.room-modal[data-voucher-modal]');
        modals.forEach((modal) => {
            const submit = modal.querySelector('.room-modal__voucher-submit') as HTMLElement;
            const inputs = modal.querySelectorAll('.room-modal__item-count') as NodeListOf<HTMLInputElement>;

            submit.addEventListener('click', (e) => {
                e.preventDefault();
                if (submit.classList.contains('room-modal__voucher-submit--disabled')) {
                    return;
                }

                const href = submit.getAttribute('href') as string;
                window.location.href = href;
            })

            inputs.forEach((input) => {
                const inputWrapper = input.closest('.room-modal__item-count-wrapper') as HTMLElement;
                const plusButton = inputWrapper.querySelector('.room-modal__item-count-plus') as HTMLElement;
                const minusButton = inputWrapper.querySelector('.room-modal__item-count-minus') as HTMLElement;

                plusButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    const inputValueNumber = parseInt(input.value, 10);
                    input.value = (inputValueNumber + 1).toString();
                    this.updateSubmit(submit);
                })

                minusButton.addEventListener('click', (e) => {
                    e.preventDefault();
                    const inputValueNumber = parseInt(input.value, 10);
                    input.value = (inputValueNumber - 1).toString();
                    this.updateSubmit(submit);
                })

                input.addEventListener('change', (e) => {
                    // change submit href after last "/" as value
                    let value = (e.target as HTMLInputElement).value;
                    let valueNumber = parseInt(value, 10);

                    if (valueNumber < 0) {
                        valueNumber = 0;
                        input.value = '0';
                    }

                    const href = submit.getAttribute('href') as string;
                    const hrefArray = href.split('/');
                    hrefArray[hrefArray.length - 1] = valueNumber.toString();
                    submit.setAttribute('href', hrefArray.join('/'));

                    this.updateSubmit(submit);
                });
            });
        });
    }

    static updateSubmit(submit: HTMLElement): void {
        const modal = submit.closest('.room-modal') as HTMLElement;
        const inputs = modal.querySelectorAll('.room-modal__item-count') as NodeListOf<HTMLInputElement>;

        const voucherItems: { [key: string]: number } = {};

        inputs.forEach((input) => {
            const itemId = input.dataset.itemId || '';
            voucherItems[itemId] = parseInt(input.value, 10) || 0;
        });

        // Save voucher items to cookies
        document.cookie = `voucherItems=${JSON.stringify(voucherItems)}; path=/; max-age=86400`;

        const voucherCount = Object.values(voucherItems).reduce((a, b) => a + b, 0);

        if (voucherCount > 0) {
            submit.classList.remove('room-modal__voucher-submit--disabled');
        } else {
            submit.classList.add('room-modal__voucher-submit--disabled');
        }

    }

}
